

import { NavigationBar } from './NavigationBar.jsx';

export const PageLayout = (props) => {
    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <NavigationBar />
            <main style={{ flex: '1', width: '100%' }}>
                {props.children}
            </main>
            <footer style={{ width: '100%', padding: '2rem 1.5rem', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1.5rem', backgroundColor: '#f8fafc', boxSizing: 'border-box' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                    <img
                        src="/persist-logo.png"
                        alt="Persist AI Logo"
                        style={{ height: '70px', width: 'auto', objectFit: 'contain' }}
                    />
                    <p style={{ margin: '0', color: '#94a3b8', fontSize: '0.95rem' }}>
                        Powered by Persist AI Formulations Corp
                    </p>
                </div>
            </footer>
        </div>
    );
}